import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircleIcon } from 'lucide-react';
const HeroSection = () => {
  return <div className="relative bg-[#0a3d62] text-white" data-id="element-28">
      <div className="absolute inset-0 z-0" data-id="element-29">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/b2GBtp9hKz58PiKz2jk4CA/04._Hero.jpg" alt="Professional appliance repair technicians" className="w-full h-full object-cover opacity-20" data-id="element-30" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a3d62] to-transparent" data-id="element-31"></div>
      </div>
      <div className="container mx-auto px-4 py-16 md:py-24 relative z-10" data-id="element-32">
        <div className="max-w-3xl" data-id="element-33">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" data-id="element-34">
            Fast, Reliable Appliance Repairs Across the UK
          </h1>
          <p className="text-lg md:text-xl mb-8 text-gray-200" data-id="element-35">
            Expert engineers, fixed-price plans, and UK-based support for all
            your household appliance needs.
          </p>
          <div className="space-y-3 mb-8" data-id="element-36">
            <div className="flex items-center" data-id="element-37">
              <CheckCircleIcon className="text-[#3fc1c9] mr-2" size={20} data-id="element-38" />
              <span data-id="element-39">Same-day or next-day appointments available</span>
            </div>
            <div className="flex items-center" data-id="element-40">
              <CheckCircleIcon className="text-[#3fc1c9] mr-2" size={20} data-id="element-41" />
              <span data-id="element-42">Experienced, qualified engineers</span>
            </div>
            <div className="flex items-center" data-id="element-43">
              <CheckCircleIcon className="text-[#3fc1c9] mr-2" size={20} data-id="element-44" />
              <span data-id="element-45">Comprehensive service plans with unlimited repairs</span>
            </div>
          </div>
          <div className="flex flex-wrap gap-4" data-id="element-46">
            <Link to="/service-coverage" className="bg-[#3fc1c9] hover:bg-[#2aa8b0] text-white font-medium py-3 px-6 rounded-md transition-colors" data-id="element-47">
              View Our Services
            </Link>
            <Link to="/contact" className="bg-transparent hover:bg-white/10 border border-white text-white font-medium py-3 px-6 rounded-md transition-colors" data-id="element-48">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>;
};
export default HeroSection;